<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :custom-label="labelSelect"
    :options="options"
    selectLabel=""
    selectedLabel=""
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading || loading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
import { timezones } from '@/constants';

export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'isObject', 'loading'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'timezone', null);
        return;
      }
      this.isObject ? this.$emit('selectChange', 'timezone', e) : this.$emit('selectChange', 'timezone', e.id);

      this.$emit('focus');
    },
    labelSelect({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (value != null) {
        if (value.id) {
          this.selected = this.options.find((option) => String(option.id) === String(value.id));
        } else {
          this.selected = this.options.find((option) => String(option.id) === String(value));
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      const data = timezones.map((tz) => {
        const offsetMinutes = this.$moment().tz(tz).utcOffset();
        const hours = Math.floor(offsetMinutes / 60);
        const minutes = Math.abs(offsetMinutes % 60);

        const offsetFormatted = `UTC ${hours >= 0 ? '+' : ''}${hours}:${minutes.toString().padStart(2, '0')}`;

        return {
          id: tz,
          nome: `(${offsetFormatted}) ${tz}`,
          numericOffset: offsetMinutes
        };
      });
      data.sort((a, b) => a.numericOffset - b.numericOffset);

      this.options = [];
      if (this.includeAll || this.emptyLabel) {
        this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
      }

      this.options = this.options.concat(data);
    }
  },
  created() {
    this.setOptions();
    this.setValue(this.nameField);
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
